import { LocalizedAttributesValue } from 'src/generated/operations.ts';
import { getRaw } from 'src/modules/common/utils/getRaw.ts';

export type IsRecommended = (label: string) => boolean;
export type GetQty = (label: string) => number;

export const parseRecommended = (
    connectors: LocalizedAttributesValue | undefined | null,
): {
    isRecommended: IsRecommended;
    getQty: GetQty;
    recommended: {
        qty: number;
        label: string;
    }[];
} => {
    const recommended: { qty: number; label: string }[] = getRaw(connectors)
        .join('')
        .split('+')
        .map((v) => {
            if (v.includes('x')) {
                const [qty, label] = v.split('x');
                return { qty: parseInt(qty || '1', 10) || 1, label };
            }
            return { qty: 1, label: v };
        });
    const isRecommended = (label: string) => recommended.find((item) => item.label === label) !== undefined;
    const getQty = (label: string): number => {
        const result = recommended.find((item) => item.label === label);
        return result ? result.qty : 1;
    };
    return {
        isRecommended,
        getQty,
        recommended,
    };
};
